import React from 'react';

const HermanNotFound = ({}) => (
  <svg viewBox="0 0 290 111" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <polygon points="0 0 69.5481956 0 69.5481956 110.689382 0 110.689382" />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-376.000000, -247.000000)">
        <g transform="translate(238.000000, 205.000000)">
          <g>
            <g>
              <g transform="translate(89.000000, 0.000000)">
                <text
                  fontFamily="Karla-Bold, Karla"
                  fontSize="160"
                  fontWeight="bold"
                  fill="#FFFFFF"
                >
                  <tspan x="46.038592" y="147">
                    4
                  </tspan>
                </text>
                <text
                  fontFamily="Karla-Bold, Karla"
                  fontSize="160"
                  fontWeight="bold"
                  fill="#FFFFFF"
                >
                  <tspan x="246.315776" y="148">
                    4
                  </tspan>
                </text>
                <g transform="translate(164.000000, 42.000000)">
                  <mask fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g />
                  <path
                    d="M34.8550379,29.4462137 C32.4029247,29.4462137 30.4762643,27.4949586 30.4762643,25.011543 C30.4762643,22.5281274 32.4029247,20.5768723 34.8550379,20.5768723 C37.3071511,20.5768723 39.2338115,22.5281274 39.2338115,25.011543 C39.2338115,27.4949586 37.3071511,29.4462137 34.8550379,29.4462137 L34.8550379,29.4462137 Z M17.6902454,48.4266045 L27.3235473,48.4266045 L27.3235473,46.6527362 L17.6902454,46.6527362 L17.6902454,48.4266045 Z M15.588434,25.011543 C15.588434,22.5281274 17.5150944,20.5768723 19.9672077,20.5768723 C22.4193209,20.5768723 24.3459813,22.5281274 24.3459813,25.011543 C24.3459813,27.4949586 22.4193209,29.4462137 19.9672077,29.4462137 C17.5150944,29.4462137 15.588434,27.4949586 15.588434,25.011543 L15.588434,25.011543 Z M39.0586606,0 C5.07937739,0 0,43.4597733 0,62.4401641 C0,83.0170363 9.80845288,89.9351227 25.046585,92.2411515 L25.046585,110.689382 L29.7756605,110.689382 L29.7756605,92.773312 C32.0526228,92.9506988 34.504736,93.1280856 37.1320002,93.1280856 L37.1320002,110.689382 L41.8610757,110.689382 L41.8610757,93.3054725 C48.1665097,93.3054725 61.3028305,87.2743203 65.8567551,71.6642792 C72.6876419,48.2492177 73.2130947,0 39.0586606,0 L39.0586606,0 Z"
                    fill="#FFFFFF"
                    mask="url(#mask-2)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default HermanNotFound;
